import axiosInstance from "../../api/axiosInstance";

/* ===============================
 TIMETABLE (PUBLIC) — legacy
================================ */
export const fetchTimeTable = () => axiosInstance.get(`/timetable`);

/* ===============================
 AVAILABLE DATES FOR A MONTH
 GET /timetable/available-dates?month=YYYY-MM
================================ */
export const fetchAvailableDates = () =>
  axiosInstance.get(`/timetable/available-dates`);

/* ===============================
 SESSIONS FOR A SPECIFIC DATE
 GET /timetable/sessions?date=YYYY-MM-DD
 Optional auth — axiosInstance sends token if present
================================ */
export const fetchSessionsByDate = (date) =>
  axiosInstance.get(`/timetable/sessions`, { params: { date } });

/* ===============================
 SESSION REMAINING SLOTS / STATUS
 - Public if userId is null
 - Protected if userId exists
================================ */
export const getSessionRemainingSlots = (sessionId, userId = null) => {
 // PUBLIC (no auth)
 if (!userId) {
 return axiosInstance.get(
 `/public/sessions/${sessionId}/remaining-slots`
 );
 }

 // AUTHENTICATED
 return axiosInstance.get(
 `/client/session/${sessionId}/remaining-slots`,
 { params: { userId } }
 );
};

/* ===============================
 BOOK SESSION
================================ */
export const bookSession = (sessionId) => {


 return axiosInstance.post(
 `/client/session/${sessionId}/book`
 );
};

/* ===============================
 CANCEL SESSION
================================ */
export const cancelSession = (sessionId) => {
 return axiosInstance.post(`/client/session/${sessionId}/cancel`
 );
};

/* ===============================
 GENERATE / GET ZOOM LINK
================================ */
export const generateZoomLink = (userId, sessionId) => {
 return axiosInstance.get(`/client/session/${sessionId}/zoom-link`, {
 params: { userId },
 });
};

/* ===============================
 GET EXISTING ZOOM LINK
================================ */
export const getExistingZoomLink = (sessionId) => {
 return axiosInstance.get(
 `/client/session/${sessionId}/zoom-link/existing`
 );
};
